import { errorToast } from "@/v2-ui/toast"
import { ConfirmButton } from "@/v2-backoffice-client/components/button"
import type { ConfirmButtonProps } from "@/v2-backoffice-client/components/button"
import { useLayerAuthoringRestoreMutation } from "@/v2-backoffice-client/layer/authoring/layer.authoring.mutation"
import { LAYER_AUTHORING_STATUSES_QUERY_NAME } from "@/v2-backoffice-client/layer/authoring/layer.authoring.constants"
import { AUTHORING_MIRROR_ENVIRONMENT } from "@/v2-backoffice-client/feature/feature.constants"

export type LayerAuthoringRestoreButtonProps = Omit<
  ConfirmButtonProps,
  "onConfirm"
> & {
  featureCode: string
}

/** Undoes a pending catalog deletion, keeping the layer in the catalog. */
function LayerAuthoringRestoreButton(props: LayerAuthoringRestoreButtonProps) {
  const { featureCode, children, ...buttonProps } = props

  const [restoreRow, { loading, error }] = useLayerAuthoringRestoreMutation({
    refetchQueries: [LAYER_AUTHORING_STATUSES_QUERY_NAME],
  })
  errorToast(error, { title: "Failed to restore layer" })

  return (
    <ConfirmButton
      variant="ghost"
      isStacked
      iconSrc="undo"
      content="Undo the pending deletion, keeping the layer in the catalog."
      confirmContent="Restore this layer in the catalog?"
      isLoading={loading}
      onConfirm={() => {
        restoreRow({
          variables: {
            input: {
              FeatureCode: featureCode,
              Environment: AUTHORING_MIRROR_ENVIRONMENT,
            },
          },
        })
      }}
      {...buttonProps}
    >
      {children ?? "Restore"}
    </ConfirmButton>
  )
}

export default LayerAuthoringRestoreButton
